module.exports = __webpack_public_path__ + "img/total.a9217630.png";